module.exports = class Images
    {
    /**
     * Constructs the object.
     */
    constructor()
    {
        this.logo = require(`./img/logo-title${__postfix}.png`);
        this.bg = require(`./img/background${__postfix}.jpg`);
        this.btnBgImage = require(`./img/button${__postfix}.png`);
        this.btnNormalImage = require(`./img/button-normal${__postfix}.png`);
        this.btnHoverImage = require(`./img/button-hover${__postfix}.png`);
        this.star = require(`./img/star${__postfix}.png`);
        this.char = require(`./img/character${__postfix}.png`);
        this.wheel = require(`./img/wheel1${__postfix}.png`);
        this.frame = require(`./img/frame${__postfix}.png`);
        this.button = require(`./img/frame-center${__postfix}.png`);
        this.buttonIcon = require(`./img/spin-sign${__postfix}.png`);
        this.buttonReflection = require(`./img/frame-center-spec-overlay${__postfix}.png`);

        this.buttonPulseJSON = require(`./sprite/green-button${__postfix}.json`);
        this.buttonPulse = require(`./sprite/green-button${__postfix}.png`);
        this.winFrameJSON = require(`./sprite/win-frame.json`);
        this.winFrame = require(`./sprite/win-frame.png`);
        this.winSignJSON = require(`./sprite/win-sign${__postfix}.json`);
        this.winSign = require(`./sprite/win-sign${__postfix}.png`);
        this.handJSON = require(`./sprite/queenhand.json`);
        this.hand = require(`./sprite/queenhand.png`);
        this.sasJSON = require(`./sprite/sas-small-reduced.json`);
        this.sas = require(`./sprite/sas-small-reduced.png`);
    }

    /**
     * Gets images needed to be preloaded
     *
     * @return {Array}  of image urls
     */
    preload()
    {
        return [
            this.logo,
            this.bg,
            this.btnBgImage,
            this.btnNormalImage,
            this.btnHoverImage,
            this.star,
            this.char,
            this.hand,
            this.star,
            this.wheel,
            this.frame,
            this.button,
            this.buttonIcon,
            this.buttonReflection,

            this.buttonPulseJSON,
            this.winFrameJSON,
            this.winFrame,
            this.winSignJSON,
            this.handJSON,
            this.sasJSON,
        ];
    }
};




// WEBPACK FOOTER //
// ./themes/fq/images.js